export default (to: any, from: any, next: any): void => {
  if (to.fullPath !== from.fullPath) {
    next()
  } else {
    // next()
  }
}
